import { BooleanFalse, BooleanTrue } from "components/icons";

function BooleanValue({ children }) {
  return children ? <BooleanTrue width={20} height={20} /> : <BooleanFalse width={20} height={20} />;
}

export default BooleanValue;
